import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuthStore } from './useAuthStore';
import { logger } from '@/lib/logger';

export const useAuth = () => {
  const { setSession, setLoading } = useAuthStore();

  useEffect(() => {
    // Set up auth state listener first
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((event, session) => {
      logger.debug('Auth state changed', { event, userId: session?.user?.id });
      setSession(session);
      setLoading(false);
    });

    // Then check for existing session
    supabase.auth
      .getSession()
      .then(({ data: { session } }) => {
        setSession(session);
        setLoading(false);
      })
      .catch((error) => {
        logger.error('Failed to get auth session', error, { component: 'useAuth' });
        setLoading(false);
      });

    return () => subscription.unsubscribe();
  }, [setSession, setLoading]);

  return useAuthStore();
};
